/*
 * @Author: songyuhang songyuhang@myhexin.com
 * @Date: 2023-07-06 15:30:03
 * @LastEditors: zhaozhenda
 * @LastEditTime: 2024-08-15 10:37:17
 */
export enum StatusCode {
  SUCCESS_CODE = 0,
  ERROR_CODE = -1,
  // eslint-disable-next-line no-magic-numbers
  REPEAT_CODE = -10003,
  // 已有俱乐部
  // eslint-disable-next-line no-magic-numbers
  CLUB_REPEAT = -10050,
}

// 用户权限
export enum UserPower {
  RESIDENT = 1,
  TOURIST,
}
